import React from "react";
import { useBeModel } from "../beModel";
import { ISearchValue, SearchTypeEnum } from "../../../../components/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components/YhPageHeader";

const searchFields = [
    {
        type: SearchTypeEnum.Input,
        xxl: 4,
        span: 4,
        placeholder: "实体编码",
        fieldName: "code",
        size: "small",
        disabled: false
    },
    {
        type: SearchTypeEnum.Input,
        xxl: 4,
        span: 4,
        placeholder: "实体名称",
        fieldName: "name",
        size: "small",
        disabled: false
    },
    {
        type: SearchTypeEnum.Select,
        xxl: 4,
        span: 4,
        placeholder: "实体状态",
        fieldName: "enable",
        size: "small",
        disabled: false,
        options: [{ label: "可用", value: 0 }, { label: "不可用", value: 1 }]
    },
]

export function PageHeader() {
    const {
        searchParam,
        loadData,
        updateSearchParam,
        resetSearchParam
    } = useBeModel();

    return (
        <YhPageHeader
            title="经营实体管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}